(function () {
  function filterSelect(select) {
    // Safari (macOS + iOS) never reliably honours `hidden`/`display:none` on
    // <option> elements inside a native <select> — the option still shows up
    // in the picker regardless. Chrome/Edge do respect it, which is why this
    // worked on Windows but not on Mac/iPhone. Removing the node from the DOM
    // is honoured by every browser, so that's what we do instead.
    var options = Array.prototype.slice.call(select.querySelectorAll('option'));
    var selectedWasRemoved = false;
    options.forEach(function (opt) {
      var unavailable = opt.disabled || /indisponibil/i.test(opt.textContent);
      if (unavailable) {
        if (opt.selected) selectedWasRemoved = true;
        opt.remove();
      }
    });
    if (selectedWasRemoved) {
      var firstVisible = select.querySelector('option');
      if (firstVisible) {
        select.value = firstVisible.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function scanAndFilter() {
    document.querySelectorAll('variant-selects select').forEach(filterSelect);
  }

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scanAndFilter();
    });
  }

  function init() {
    scanAndFilter();

    document.querySelectorAll('variant-selects').forEach(function (el) {
      var observer = new MutationObserver(scheduleScan);
      observer.observe(el, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled'],
        characterData: true
      });
    });

    // Belt-and-suspenders: Dawn re-renders variant state via a fetch that can
    // land a moment after the change event fires, so re-scan a couple of
    // times after any change inside the variant picker.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) {
        setTimeout(scanAndFilter, 50);
        setTimeout(scanAndFilter, 300);
        setTimeout(scanAndFilter, 800);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
